export interface IVerticalViewportResult {
  top: boolean;
  bottom: boolean;
}

export function isElementVisibleInVerticalViewport(el: Element, scrollContainer?: Element | null): IVerticalViewportResult {
  const { top, bottom } = el.getBoundingClientRect();
  let scrollContainerTop = window.innerHeight;
  let scrollContainerBottom = window.innerHeight;

  if (scrollContainer) {
    const scrollContainerRect = scrollContainer.getBoundingClientRect();

    scrollContainerTop = scrollContainerRect.top;
    scrollContainerBottom = scrollContainerRect.bottom;
  }

  return {
    top: top > 0 && top > scrollContainerTop,
    bottom: bottom > 0 && bottom < scrollContainerBottom,
  };
}

export function scrollElementIntoView(elementId: string, scrollContainerId?: string): void {
  const element = document.querySelector(elementId);
  const scrollContainer = scrollContainerId ? document.querySelector(scrollContainerId) : null;

  if (!element)
    return;

  const visibility = isElementVisibleInVerticalViewport(element, scrollContainer);

  if (visibility.top && visibility.bottom)
    return;

  element.scrollIntoView({
    behavior: 'smooth',
    block: !visibility.bottom ? 'end' : 'start',
  });
}
